import styled from '@emotion/styled'

export const RootWrap = styled('div')(`
    // margin-top: 20px;
`)
